/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const PhotoColumnFormatter = (cellContent, row) => (
  <div
    className="image-input image-input-outline"
    id="teacher_photo"
    style={{ backgroundImage: `url(${toAbsoluteUrl("/media/users/blank.png")}`}}
  >
    <div
      className="image-input-wrapper"
      style={{ maxWidth: "80px", maxHeight: "80px", backgroundImage: `url(${row.photoStr})` }}
    />
  </div>
);